import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getGradeList } from "../../actions/Grade.action";
import AddSchoolPerformanceForm from "../../components/AddSchoolPerformanceForm/AddSchoolPerformanceForm";
import Layout from "../../components/shared/Layout/Layout";

const AddSchoolPerformancePage = ({ edit, grades, getGradeList }) => {
  const { id } = useParams();
  useEffect(() => {
    getGradeList();
  }, [getGradeList]);
  return (
    <div className="bg_light">
      <Layout title={`${edit ? "Edit" : "Add"} School Performance`}>
        {edit && id && grades ? (
          <AddSchoolPerformanceForm grades={grades} />
        ) : (
          <AddSchoolPerformanceForm grades={grades ? grades : []} />
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(AddSchoolPerformancePage);
